import { Map } from 'immutable'
import * as actions from './actions'
import * as lessonsActions from '../../lessons/actions'

const fieldsReducer = (state = Map(), action) => {
  switch (action.type) {
    case actions.FIELDS_RESET_FIELDS: {
      const { path } = action.payload
      return state.deleteIn(path)
    }
    case actions.FIELDS_SET_FIELD: {
      const { path, value } = action.payload
      return state.setIn(path, value)
    }
    case lessonsActions.LESSON_ADD_FAVORITE_SUCCESS:
    case lessonsActions.LESSON_ADD_SUCCESS: {
      const addedLesson = action.payload.data

      let testFormState = state.get('OnboardingTestForm')
      if (testFormState) {
        const currentStateTestForm = testFormState && testFormState.toJS()
        if (currentStateTestForm && addedLesson) {
          let lessons = currentStateTestForm.lessons || []
          lessons.push(addedLesson.id)
          return state.setIn(['OnboardingTestForm', 'lessons'], lessons)
        }
      }
      
      testFormState = state.get('TestForm')
      if (testFormState) {
        const currentStateTestForm = testFormState && testFormState.toJS()
        if (currentStateTestForm && addedLesson) {
          let lessons = currentStateTestForm.lessons || []
          lessons.push(addedLesson.id)
          return state.setIn(['TestForm', 'lessons'], lessons)
        }
      }

      return state
    }
    case lessonsActions.LESSON_EDIT_SUCCESS: {
      const editedLesson = action.payload.data

      const testFormState = state.get('TestForm')
      const currentStateTestForm = testFormState && testFormState.toJS()
      if (currentStateTestForm && editedLesson.deletedLesson) {
        let { lessons } = currentStateTestForm
        lessons = lessons.filter(l => l !== editedLesson.deletedLesson)
        lessons.push(editedLesson.id)
        return state.setIn(['TestForm', 'lessons'], lessons)
      }

      const homeworkFormState = state.get('HomeworkForm')
      const currentStateHomeworkForm = homeworkFormState && homeworkFormState.toJS()
      if (currentStateHomeworkForm && editedLesson.deletedLesson) {
        let { lessons } = currentStateHomeworkForm
        lessons = lessons.filter(l => l !== editedLesson.deletedLesson)
        lessons.push(editedLesson.id)
        return state.setIn(['HomeworkForm', 'lessons'], lessons)
      }
      return state
    }

    default:
      return state
  }
}

export default fieldsReducer



// WEBPACK FOOTER //
// ./src/common/lib/redux-fields/reducer.js